import { AppShell, AppShellBody } from 'components/layout/AppShell';
import { LoadingSpinner } from 'components/loaders';
import { MimicBanner } from 'components/user/mimic-banner/MimicBanner';
import { useAuth } from 'hooks';
import React, { Suspense } from 'react';
import { Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom';
import routes from 'routes';
import { AuthStateEnum } from 'utils/constants/auth.constant';
import { lazyWithRetry } from 'utils/lazyWithRetry';

const AuthPage = lazyWithRetry(() => import('pages/auth/Auth'));

export function AuthGuard({ children }: React.PropsWithChildren<any>) {
  const { authState, user } = useAuth();
  const { businessId } = useParams<{ businessId: string }>();
  const location = useLocation();

  const businessIds = user?.memberships?.map((x) => x.businessId);

  if (authState === AuthStateEnum.AUTHENTICATED) {
    // if on a businessId that is not in memberships
    if (businessId && !businessIds?.includes(Number(businessId))) {
      return <Navigate to={'/'} replace />;
    }

    return (
      <AppShell>
        <MimicBanner />
        <AppShellBody>{children}</AppShellBody>
      </AppShell>
    );
  }

  if (authState === AuthStateEnum.UNAUTHENTICATED) {
    return (
      <Routes>
        <Route
          path={routes.auth.route}
          element={
            <Suspense fallback={<LoadingSpinner />}>
              <AuthPage />
            </Suspense>
          }
        />
        <Route
          path="/*"
          element={<Navigate replace to={{ ...location, pathname: routes.auth.getAbsolute() }} />}
        />
      </Routes>
    );
  }

  return null;
}
